<form [formGroup]="telemarketingForm">
  <div class="row">
    <div class="col-12 col-md-6 mb-3">
      <label for="telemarketing_status" class="form-label">
        {{ "inputs.telemarketing_status" | translate }}
      </label>
      <ng-select formControlName="telemarketing_status"
        [items]="telemarketingData?.telemarketing_statuses" bindValue="key" bindLabel="name"
        [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false"
        [notFoundText]="'tables.no_results' | translate"
        [readonly]="isLoading || telemarketingData?.telemarketing_statuses?.length === 0"
        (change)="onSelectChange($event)">
      </ng-select>
      <div *ngIf="isLoading" class="mt-2">
        <small class="text-muted">Cargando estados...</small>
      </div>
    </div>
    <div class="col-12 col-md-6 d-flex align-items-center"   *ngIf="idArgumentaryLoaded">
      <span
        (click)="showPopout()"
        class="clickable text-decoration-underline"
      >
        {{ "tooltip.telemarketing_argumentary" | translate }}
      </span>
    </div>
  </div>
  <div class="row linea"></div>
  <div class="row">
    <div class="col-12 col-md-6 mb-3">
      <label for="phone" class="form-label">{{
        "inputs.phone" | translate
      }}</label>
      <div class="input-group div-copy">
        <input
          type="text"
          class="form-control"
          disabled
          [value]="orderData.client?.phone"
          #inputFieldphone
        />

        <div class="input-group-append">
          <button
            class="btn btn-outline-secondary copy"
            type="button"
            (click)="copyToClipboard(inputFieldphone.value, $event)"
          >
            <i class="icon-copy"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 mb-3">
      <label for="email" class="form-label">{{
        "inputs.email" | translate
      }}</label>
      <div class="input-group div-copy">
        <input
          type="text"
          class="form-control"
          disabled
          [value]="orderData.client?.email"
          #inputFieldemail
        />

        <div class="input-group-append">
          <button *ngIf="orderData.client?.email && orderData.client?.reference"
            class="btn btn-outline-secondary copy"
            type="button"
            (click)="openMailModal(orderData.client.reference)"
            [title]="'buttons.send_mail' | translate"
          >
            <i class="icon-envelope"></i>
          </button>
          <button
            class="btn btn-outline-secondary copy"
            type="button"
            (click)="copyToClipboard(inputFieldemail.value, $event)"
          >
            <i class="icon-copy"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-6 mb-3">
      <label for="vin" class="form-label">{{
        "inputs.vin" | translate
      }}</label>
      <div class="input-group div-copy">
        <input
          type="text"
          class="form-control"
          id="vin2"
          required
          formControlName="vin2"
          placeholder="{{ 'inputs.vin' | translate }}"
          #inputFieldvin
        />

        <div class="input-group-append">
          <button
            class="btn btn-outline-secondary copy"
            type="button"
            (click)="copyToClipboard(inputFieldvin.value, $event)"
          >
            <i class="icon-copy"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 mb-3">
      <label for="license_plate" class="form-label">{{
        "inputs.license_plate" | translate
      }}</label>
      <div class="input-group div-copy">
        <input
          type="text"
          class="form-control"
          id="license_plate2"
          required
          formControlName="license_plate2"
          placeholder="{{ 'inputs.license_plate' | translate }}"
          #inputFieldplate
        />

        <div class="input-group-append">
          <button
            class="btn btn-outline-secondary copy"
            type="button"
            (click)="copyToClipboard(inputFieldplate.value, $event)"
          >
            <i class="icon-copy"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="row linea"></div>
  <div class="col-12 col-md-4 mb-3">
    <label for="telemarketing_action_status" class="form-label">
      {{ "inputs.telemarketing_action_status" | translate }}
    </label>
    <ng-select formControlName="telemarketing_action_status"
      [items]="telemarketingData?.action_statuses" bindValue="key" bindLabel="name"
      [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false"
      [notFoundText]="'tables.no_results' | translate"
      [readonly]="isLoading">
    </ng-select>
  </div>

  <div class="col-12 col-md-4 mb-3">
    <label for="telemarketing_action_date" class="form-label">
      {{ "inputs.telemarketing_action_date" | translate }}
    </label>

    <div class="input-group">
      <mat-form-field appearance="fill" class="w-100">
        <input
          matInput
          [matDatepicker]="actionDatePicker"
          (dateChange)="onDateSelected($event)"
          formControlName="telemarketing_action_date"
          placeholder="{{ 'inputs.select_date_and_hour' | translate }}"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="actionDatePicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #actionDatePicker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="time-picker-container" *ngIf="showTimePicker">
      <div class="time-picker-header">
        <h6>{{ "inputs.select_hour" | translate }}</h6>
        <span class="selected-date" *ngIf="selectedDate">
          {{ getFormattedDate() }}
        </span>
        <span class="selected-date" *ngIf="!selectedDate">
          Primero selecciona una fecha
        </span>
      </div>

      <div class="time-picker-body">
        <div class="time-section">
          <label class="time-label">{{
            "inputs.hour" | translate
          }}</label>
          <div class="time-options">
            <div
              *ngFor="let hour of hours"
              class="time-option"
              [class.selected]="selectedHour === hour"
              (click)="selectHour(hour)"
            >
              {{ hour.toString().padStart(2, "0") }}
            </div>
          </div>
        </div>
        <div class="time-section">
          <label class="time-label">{{
            "inputs.minutes" | translate
          }}</label>
          <div class="time-options">
            <div
              *ngFor="let minute of minutes"
              class="time-option"
              [class.selected]="selectedMinute === minute"
              (click)="selectMinute(minute)"
            >
              {{ minute.toString().padStart(2, "0") }}
            </div>
          </div>
        </div>
      </div>

      <div class="time-picker-footer">
        <a>
          <span class="goDocs" (click)="clearSelection()">
            {{ "inputs.clean_date" | translate }}
          </span>
        </a>
        <button
          type="button"
          class="btn btn-primary btn-sm"
          (click)="confirmTimeSelection()"
        >
          {{ "inputs.confirm" | translate }}
        </button>
      </div>
    </div>

    <div class="debug-info" *ngIf="selectedDate">
      <small
        >{{ "inputs.selected_hour" | translate }}: {{ selectedHour }}:{{
          selectedMinute.toString().padStart(2, "0")
        }}</small
      >
    </div>
  </div>

  <div class="row linea"></div>
  <div class="col-12 mb-3">
    <div class="row">
      <label for="notes" class="form-label">{{
        "inputs.telemarketing_notes" | translate
      }}</label>
      <div class="input-group">
        <textarea
          class="form-control textarea150"
          id="notes"
          rows="5"
          formControlName="telemarketing_notes"
        ></textarea>
      </div>
    </div>
  </div>
</form>

